import common from "@charmdeer/common";

import { getRestCity, getRestTpHotel } from "@/api/rest/common";

/**
 * 把地点弹层里选中的原始项（历史记录 / 城市）统一成搜索用的 location 对象
 */
export const resolveLocationSelection = async (
  rawItem,
  { language, showHotelEnName }
) => {
  let standardLocation = null;

  try {
    if (rawItem.type === "city") {
      const cityData = rawItem.data;
      standardLocation = {
        ...cityData,
        locationType: "city",
        showLabel: common.city.toString.name(cityData, language)
      };
    } else if (rawItem.type === "history") {
      const historyData = rawItem.data;

      if (historyData.target) {
        const { ref, collectionName } = historyData.target;
        if (collectionName === "hotel" || collectionName === "moduleTpHotel") {
          const hotelData = await getRestTpHotel(ref);
          standardLocation = {
            ...hotelData,
            locationType: "moduleTpHotel",
            showLabel: common.moduleTpHotel.toString.name(hotelData, language),
            showHotelEnName
          };
        } else if (collectionName === "city") {
          const cityData = await getRestCity(ref);
          standardLocation = {
            ...cityData,
            locationType: "city",
            showLabel: common.city.toString.name(cityData, language)
          };
        }
      } else if (historyData.info) {
        const { collectionName, place_id, description } = historyData.info;
        if (collectionName === "google") {
          standardLocation = {
            _id: place_id,
            showLabel: description,
            locationType: "googleMapPolitical"
          };
        } else if (collectionName === "keyword") {
          standardLocation = {
            _id: historyData.text,
            showLabel: historyData.text,
            locationType: "search"
          };
        }
      } else if (historyData.text) {
        standardLocation = {
          _id: historyData.text,
          showLabel: historyData.text,
          locationType: "search"
        };
      }
    }
  } catch (error) {
    const keyword = rawItem.data?.text || rawItem.data?.showLabel || "";
    if (keyword) {
      standardLocation = {
        _id: keyword,
        showLabel: keyword,
        locationType: "search"
      };
    }
  }

  return standardLocation;
};
